import PetsIcon from '@/assets/img/user-default-icon.png';
import { ReactComponent as CloseIcon } from '@/assets/img/close-icon-new-v2.svg';
import { CalendarUsers } from '@/features/Calendar/types';
import './SelectedServiceProviders.scss';
export type SelectedServiceProvidersProps = {
  selectedServiceProviders?: CalendarUsers[];
  removeProvider: (sp: CalendarUsers) => void;
};

export const SelectedServiceProviders = ({
  selectedServiceProviders,
  removeProvider,
}: SelectedServiceProvidersProps) => {
  return (
    <div className="flex gap-1 selected-providers">
      {selectedServiceProviders?.map((serviceProvider: any) => {
        console.log(serviceProvider);

        const avatar_url = serviceProvider.avatarUrl ? serviceProvider.avatarUrl : serviceProvider.avatar_url;
        const spName = serviceProvider.name ? serviceProvider.name : serviceProvider.firstName + ' ' + serviceProvider.lastName;
        return (
          <span className="profile-hg rounded-full">
            <img
              className={`rounded-full ${avatar_url ? '' : 'is-user-icon'}`}
              referrerPolicy="no-referrer"
              src={avatar_url ? avatar_url : PetsIcon}
            />
            <span className="rounded-full overlay flex justify-center items-center">
              <CloseIcon onClick={() => removeProvider(serviceProvider)} />
            </span>
            <div className="provider-details">
              <div>
                <p>{spName}</p>
                <p>{serviceProvider.email}</p>
              </div>
            </div>
          </span>
        );
      })}
    </div>
  );
};

SelectedServiceProviders.displayName = 'SelectedServiceProviders';
